/*
 * @Author: 陈乾
 * @Date: 2021-10-25 10:59:04
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:01:16
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/api/index.js
 */

import base from './base'

export default {
  ...base
}
